export const WIDGET_ID = 'openbay';
